import React from "react";

export default function StatsCard({
  value,
  total,
  label,
  icon,
  iconBg,
  trendText,
  trendType = "up",
}) {
  return (
    <div className="stats-card">
      {/* Icon */}
      <div className="icon-box" style={{ background: iconBg }}>
        {icon}
      </div>

      {/* Value */}
      <h3 className="value">
        {value} <span>/ {total}</span>
      </h3>

      {/* Label */}
      <p className="label">{label}</p>

      {/* Divider */}
      <div className="divider" />

      {/* Trend */}
      <div className="trend">
        <div
          className={`trend-icon ${trendType === "up" ? "up" : "down"}`}
        >
          {trendType === "up" ? "↑" : "↓"}
        </div>
        <span>{trendText}</span>
      </div>
      <style>
        {
          `


/* Card */
.stats-card {
  background: #ffffff;
  border-radius: 6px;
  // padding: 18px;
  border: 1px solid #e5e7eb;
  position: relative;
  transition: 0.2s ease;
}

.stats-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* Icon */
.icon-box {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

/* Value */
.value {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.value span {
  font-size: 18px;
  color: #6b7280;
  font-weight: 500;
}

/* Label */
.label {
  font-size: 14px;
  color: #6b7280;
  margin-top: 4px;
}

/* Divider */
.divider {
  height: 1px;
  background: #e5e7eb;
  margin: 12px 0;
}

/* Trend */
.trend {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
}

/* Trend Icon */
.trend-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}

.trend-icon.up {
  background: #16a34a;
}

.trend-icon.down {
  background: #dc2626;
}

/* 📱 Mobile Responsive */
@media (max-width: 992px) {
  .stats-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .stats-container {
    grid-template-columns: 1fr;
  }

  .value {
    font-size: 22px;
  }
}`
        }
      </style>
    </div>
  );
}